import { CubeIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'libs/i18n'
import { NavLink } from 'libs/router'
import { Currency, Panel, PanelEmpty, TableImage } from 'shared/components'
import { Spinner } from 'shared/atoms'
import { routes } from 'config/routes'
import { useFetchProducts } from './queries/useFetchProducts'
import { MAX_PANEL_ITEMS, viewAllClassName } from '../panel'

type UserProductsProps = {
	userId: string
}

export const UserProducts = ({ userId }: UserProductsProps) => {
	const { t } = useTranslation()
	const { products, isProductsLoading } = useFetchProducts(userId)
	const results = products?.data?.results ?? []

	const renderContent = () => {
		if (isProductsLoading && !results.length) return <Spinner />
		if (!results.length) return <PanelEmpty>{t('No products yet')}</PanelEmpty>

		return (
			<ul className="divide-y divide-border">
				{results.slice(0, MAX_PANEL_ITEMS).map((product) => (
					<li key={product.id} className="flex items-center gap-3 py-2 text-[12px]">
						<TableImage src={product.image_thumbnail} />
						<div className="min-w-0 flex-1">
							<NavLink
								className="block truncate font-medium text-foreground hover:text-primary"
								to={routes.productEdit(String(product.id))}>
								{product.name}
							</NavLink>
							<span className="block truncate text-[11px] text-muted-foreground">
								{product.sku}
							</span>
						</div>
						<Currency className="shrink-0 font-medium tabular-nums" price={product.price} />
					</li>
				))}
			</ul>
		)
	}

	return (
		<Panel
			title={t('Products')}
			icon={<CubeIcon />}
			action={
				results.length > 0 && (
					<NavLink className={viewAllClassName} to={`${routes.productIndex}?owner_id=${userId}`}>
						{t('View all')}
					</NavLink>
				)
			}>
			{renderContent()}
		</Panel>
	)
}
